module.exports = __webpack_public_path__ + "static/img/licesence-03_rotated.331eab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/licesence-03_rotated.jpg
// module id = 0XrV
// module chunks = 1